import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneCaricaDocumentoLulStep2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices',
        '$sce',
        '$filter'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices,
        private $sce: ng.ISCEService,
        private $filter: ng.IFilterService
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';
        $scope.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
        $scope.years = [];
        $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');

        $scope.setYears = () => {
            let curr_year = new Date().getFullYear();
            $scope.years.push(curr_year);
        };

        $scope.setYears();

        if (store.get('conservazioneClasseDocumentale') === null) {
            $state.go('home.conservazione-carica-documento-step1');
            return;
        }

        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

        $scope.prev = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
        };

        // <editor-fold desc='openWorkerModal'>
        $scope.openWorkerModal = (size) => {

            $scope.settings.mese = $scope.months[$scope.settings.meseId];

            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerVersamentoModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: () => {
                        return $scope.settings;
                    },
                    classeDocumentale: () => {
                        return 'lul';
                    }
                }
            });
        };
        // </editor-fold>

        $rootScope.formsubmitted = false;

        // <editor-fold desc='setConservazioneSettings'>
        $scope.setConservazioneSettings = () => {
            let classeDocumentale = $scope.settings.classeDocumentale.key;

            let userSettings = {
                'key': classeDocumentale,
                'value': $scope.settings
            };

            ArchiSmallServices.setConservazioneSettings(userSettings)
                .then((response: any) => {
                    // ??
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        // <editor-fold desc='getConservazioneSettings'>
        $scope.getConservazioneSettings = () => {
            $rootScope.readyToUse = false;
            $scope.currentClasseDocumentale = $scope.classeDocumentale;
            ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
                .then((response: any) => {
                    if (response !== undefined && response !== '') {
                        $scope.settings = response.value;
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

                    } else {
                        $scope.settings = $scope.getSettingsDefault();
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                        $scope.filesIndex = $scope.settings.files.length;
                        $rootScope.filesUploadedNumber = $scope.filesIndex;
                    }
                    $rootScope.readyToUse = true;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        if ($scope.classeDocumentale !== '') {
            $scope.getConservazioneSettings();
        }
    }
}

export const ConservazioneCaricaDocumentoLulStep2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-lul-step2.html'),
    controller: ConservazioneCaricaDocumentoLulStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-lul-step2/conservazione-carica-documento-lul-step2.ts